var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M4.25,5.61C6.57,8.59,10,13,10,13v5a2.006,2.006,0,0,0,2,2h0a2.006,2.006,0,0,0,2-2V13s3.43-4.41,5.75-7.39A1,1,0,0,0,18.95,4H5.04A1,1,0,0,0,4.25,5.61Z",
    transform: "translate(-4.038 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.69c939330719b3e693ed08572a8ae3f2.svg";
export { ForwardRef as ReactComponent };